import { HttpErrorResponse } from '@angular/common/http';
import { Component, OnDestroy, OnInit } from '@angular/core';
import { MessageService } from 'primeng/api';
import { Observable, Subject } from 'rxjs';
import { ApiService } from '../../services/api.service';

@Component({
  selector: 'app-page-base',
  imports: [
  ],
  template: ``,
  styles: ``,
  providers: [MessageService]
})
export abstract class PageBaseComponent<T> implements OnInit, OnDestroy {
  loading: boolean = false;
  dtTrigger: Subject<boolean> = new Subject<boolean>();

  newItem!: T;
  selectedItem!: T;
  isNew: boolean = false;

  showDialog: boolean = false;
  tabId: number = 0;

  constructor(protected apiService: ApiService, protected messageService: MessageService) {
    this.resetItems();
  }

  ngOnInit(): void {
    this.loadData();
    this.tabId = 0;
  }

  ngOnDestroy() {
    this.dtTrigger.unsubscribe();
  }

  showSuccess(message: string) {
    this.messageService.add({ key: 'tc', severity: 'success', summary: 'Success', detail: message });
  }

  showError(err: HttpErrorResponse) {
    let message: string = err.error !== null ? (typeof err.error === 'string' ? err.error : err.error.message) : err.message
    this.showErrorMessage(message);
  }

  showErrorMessage(message: string) {
    this.messageService.add({ key: 'tc', severity: 'error', summary: 'Error', detail: message });
  }

  onCloseDialog(): void {
    this.showDialog = false;
  }

  abstract onSave(): void;

  onShowDialog(item: T): void {
    this.tabId = 0;
    this.selectedItem = { ...item }

    this.loadSelectedInfo().subscribe({
      next: (r) => {
        if (r) {
          this.dtTrigger.next(true);
          this.showDialog = true;
        } else {
          this.showErrorMessage("Errore nella procedura!");
        }
      },
      error: (err: HttpErrorResponse) => {
        this.showError(err);
      }
    });
  }

  protected abstract loadData(): void;
  protected abstract loadSelectedInfo(): Observable<boolean>;
  protected abstract resetItems(): void;
}
